@if (mappedContent()) {
  <div class="mr-large-b">
    @if (showTitle()) {
      <h2 class="mr-medium-b">
        {{ mappedContent().teaserTitle }}
      </h2>
    }

    @for (item of mappedContent().items; track item; let index = $index, last = $last) {
      <fin-expand
        class="block"
        [initiallyOpen]="(item.segment | decodeURI: true) === routeFragment"
        [class.border-bottom]="last"
        [key]="'cms-accordion-' + mappedContent().contentId"
        [id]="'cms-accordion-' + mappedContent().contentId + '-' + index"
        #expand
      >
        <div
          class="trigger flex flex--center border-top"
          tabindex="-1"
          [class.pr-xxsmall-y]="withPictures()"
          [class.pr-small-y]="!withPictures()"
        >
          @if (item.previewPicture && withPictures()) {
            <div class="mr-xsmall-r">
              <fin-content-image
                class="valign-middle preview-image"
                [imageData$]="item.previewPicture | finToObservable"
                [aspectRatio$]="'16x9' | finToObservable"
                [enableLqip]="false"
              />
            </div>
          }
          <div class="flex-1 nordic-blue-900-text text-icon-primary" data-testid="accordion-teaser-title">
            @if (!withPictures()) {
              <h2 class="mr-clear-t" data-testid="accordion-no-image-teaser-title">
                {{ item.teaserTitle }}
              </h2>
            }
            @if (withPictures()) {
              <h3 class="mr-clear-t" data-testid="accordion-image-teaser-title">
                {{ item.teaserTitle }}
              </h3>
            }
          </div>
          <fcom-icon
            class="flex-1 flex--nogrow rotate icon-medium"
            [class.rotate-active]="expand.isOpen$ | async"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
        <div class="content">
          <fin-cms-json-content [template$]="{ main: [item] } | finToObservable" />
        </div>
      </fin-expand>
    }
  </div>
}
